// extracted by mini-css-extract-plugin
module.exports = {"betaBeta":"betaBadge-module__betaBeta___1Ovr9","isSmall":"betaBadge-module__isSmall___2qWnd"};